<template>
  <vs-row class="bg-primary" vs-justify="center" vs-align="center">
    <vs-col vs-lg="6" vs-offset="-2" vs-xs="12">
      <div class="container">
        <div style="margin-left: 10px">
          <b-img
            :src="require('@/assets/images/logo/sentenance_logo.png')"
            fluid
            alt="Fluid image"
          ></b-img>
        </div>
        <br />

        <div class="container">
          <h2 id="getting-started">
            <a href="#getting-started" class="header-anchor">Sign</a> In
          </h2>
          <br />

          <vs-input
            color="#333f50"
            icon-no-border
            icon="account_circle"
            label="Username"
            class="inputx ml-3"
            type="string"
            placeholder="Username"
            v-model="username"
          />

          <br />

          <vs-input
            color="#333f50"
            icon-no-border
            icon="https"
            label="Password"
            class="inputx ml-3"
            type="password"
            placeholder="Password"
            v-model="password"
            @keydown.enter="login"
          />
          <vs-col>
            <!-- <vs-button line-origin="left" color="success" type="line" @click="register()">Register</vs-button>&nbsp;&nbsp;&nbsp;&nbsp;
          <vs-button line-origin="left" color="warning" type="line" href="/forgotpassword">Forgot password?</vs-button>&nbsp;&nbsp;&nbsp;&nbsp; -->
            <br /><br />
          </vs-col>
        </div>

        <vs-row>
          <vs-col
            vs-offset="2"
            v-tooltip="'col - 8'"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="8"
          >
            <vs-button
              color="success"
              type="border"
              @click="login()"
              style="padding: 14px 30px; border-radius: 12px"
              >SIGN IN</vs-button
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </vs-col>
        </vs-row>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    username: "",
    password: "",
    checkbox: false,
    loading: false,
  }),
  components: {},
  methods: {
    push(token, user, pack, perm, mode) {
      this.$session.set("token", token);
      this.$session.set("username", user);
      this.$session.set("package", pack);
      this.$session.set("controlperm", perm);
      this.$session.set("role", mode);
      this.$API
        .post("checkin", {
          username: this.$session.get("username"),
        })
        .catch((err) => {
          // console.log(err)
        });
      this.activeLoading = true;
      this.$vs.loading({
        type: "default",
      });
      setTimeout(() => {
        this.activeLoading = false;
        this.$vs.loading.close();
        this.$router.push({
          name: "Overview",
        });
      }, 500);
    },
    async login() {
      await this.$API
        .post("login", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          username: this.username,
          password: this.password,
          role: this.checkbox,
        })
        .then((result) => {
          // console.log(result.data[0])
          if (result.status == 200) {
            if (result.data[0].status == "login") {
              this.$vs.notify({
                title: "Login was unsuccessful",
                text: "Please wait for session expire or This user is already login",
                color: "danger",
                position: "top-center",
                icon: "clear",
              });
            } else if (result.data[0].admin) {
              this.$API
                .get("getAdmintoken/" + result.data[0].admin)
                .then((tresult) => {
                  this.$API
                    .post("checkin", {
                      username: this.$session.get("username"),
                    })
                    .catch((err) => {
                      // console.log(err)
                    });
                  // console.log(tresult.data)
                  this.push(
                    tresult.data,
                    result.data[0].username,
                    result.data[0].package,
                    result.data[0].controlperm,
                    "user"
                  );
                });
            } else {
              this.push(
                result.data[0].token,
                result.data[0].username,
                result.data[0].package,
                null,
                "admin"
              );
            }
          }
        })
        .catch((err) => {
          // console.log(err.response)
          if (err.response.status == 401) {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "The username or password provided is incorrect.",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          } else if (err.response.status == 403) {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "Please wait for session expire or This user is already login",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          } else {
            this.$vs.notify({
              title: "Login was unsuccessful",
              text: "Something happen with the server",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          }
        });
    },
    register() {
      this.$router.push({
        name: "Register",
      });
    },
  },
  async created() {
    await FingerprintJS.load().then((fp) => {
      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      fp.get().then((result) => {
        this.$http
          .post(this.$url2 + "rememberme", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            fingerprint: result.visitorId,
          })
          .then((result) => {
            if (result.status == 200) {
              let data = result.data;
              if (data.user.admin) {
                let user = data.user;
                this.push(
                  data.accessToken,
                  data.refreshToken,
                  user.token,
                  user.username,
                  user.package,
                  user.controlperm,
                  "user",
                  user.admin,
                  user.ischeckform
                );
              } else {
                console.log("case 2");
                let user = data.user;
                this.push(
                  data.accessToken,
                  data.refreshToken,
                  user.token,
                  user.username,
                  user.package,
                  null,
                  "admin",
                  user.username,
                  user.ischeckform
                );
              }
            }
          });
      });
    });
  },
};
</script>
<style scoped>
.default-input {
  display: flex;
  align-items: flex-end;
  position: static;
}
.inputx {
  margin: 10px;
}
.vs-input {
  width: 100%;
}
input.vs-inputx.vs-input--input.normal.hasValue.hasIcon {
  border-radius: 20px;
}

@media screen and (max-width: 500px) {
  button.vs-component.vs-button.vs-button-success.vs-button-border {
    left: 20px;
  }
}
</style>
